const SkeletonCard = () => (
    <div className="p-4 bg-white border rounded-lg w-full md:w-1/4 animate-pulse">
        <div className="flex flex-row items-center justify-between mb-4">
            <div className="flex items-center gap-2">
                <div className="w-5 h-5 md:w-6 md:h-6 bg-gray-300 rounded"></div>
                <div className="h-5 md:h-6 w-16 md:w-20 bg-gray-300 rounded"></div>
            </div>
            <div className="h-3 md:h-4 w-10 md:w-12 bg-gray-300 rounded-full"></div>
        </div>
        <div className="mb-4">
            <div className="h-3 md:h-4 w-28 md:w-32 bg-gray-300 rounded mb-2"></div>
            <div className="h-3 md:h-4 w-20 md:w-24 bg-gray-300 rounded"></div>
        </div>
        <div className="mb-4">
            <div className="h-3 md:h-4 w-28 md:w-32 bg-gray-300 rounded mb-2"></div>
            <div className="h-3 md:h-4 w-20 md:w-24 bg-gray-300 rounded"></div>
        </div>
        <div>
            <div className="h-3 md:h-4 w-28 md:w-32 bg-gray-300 rounded mb-2"></div>
            <div className="h-3 md:h-4 w-20 md:w-24 bg-gray-300 rounded"></div>
        </div>
    </div>
);

const StatisticsTabSkeleton = () =>(
    <div className="w-full flex flex-col shadow-lg p-4 md:p-6 bg-white rounded-2xl md:rounded-3xl item-start">
        <div className="flex flex-col items-center mb-4 border-b border-gray-200">
            <div className="h-6 md:h-8 w-40 md:w-48 bg-gray-300 rounded mb-4 animate-pulse"></div>
        </div>
        <div className="h-5 md:h-6 w-28 md:w-32 bg-gray-300 rounded mb-4 animate-pulse"></div>
        <div className="flex flex-col md:flex-row md:justify-between gap-4 mb-4">
            <SkeletonCard />
            <SkeletonCard />
            <SkeletonCard />
            <SkeletonCard />
        </div>
        <div className="mb-4">
            <div className="h-5 md:h-6 w-40 md:w-48 bg-gray-300 rounded mb-4 animate-pulse"></div>
            <div className="p-4 w-full h-48 md:h-64 rounded-lg bg-gray-200 animate-pulse"></div>
        </div>
        <div className="mb-4">
            <div className="h-5 md:h-6 w-28 md:w-32 bg-gray-300 rounded mb-4 animate-pulse"></div>
            <div className="w-full h-48 md:h-64 rounded-lg bg-gray-200 animate-pulse"></div>
        </div>
    </div>
);


const AccountDetailsSkeleton = () => (
    <div className='w-full bg-white p-4 md:p-7 rounded-2xl md:rounded-3xl shadow-lg'>
        {/* Lead Ownership Section */}
        <div className="flex flex-col md:flex-row md:justify-between md:items-start gap-3 md:gap-0">
            <div className="flex items-center">
                <p className="font-bold text-lg md:text-2xl">Account Ownership</p>
            </div>
        </div>

        {/* Grid Container for All Rows */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-5 ml-2 md:ml-5 text-[#475569]">
            {/* Product Ownership Section */}
            <div className="flex flex-col md:flex-row md:items-start mt-3 md:mt-5">
                <div className='border-b border-gray-200 pb-2 w-full flex flex-col md:flex-row gap-1 md:gap-0'>
                    <span className="w-full md:w-1/3 font-bold md:font-normal text-sm md:text-base"><b>Name in MMT</b></span>
                    <div className="h-5 w-full md:w-1/3 bg-gray-300 rounded-lg animate-pulse"></div>
                </div>
            </div>
            <div className="flex flex-col md:flex-row md:items-start mt-3 md:mt-5">
                <div className='border-b border-gray-200 pb-2 w-full flex flex-col md:flex-row gap-1 md:gap-0'>
                    <span className="w-full md:w-1/3 font-bold md:font-normal text-sm md:text-base"><b>Account Source</b></span>
                    <div className="h-5 w-full md:w-1/3 bg-gray-300 rounded-lg animate-pulse"></div>
                </div>
                
            </div>

            {/* Contact Method and Lead Source */}
            <div className="flex flex-col md:flex-row md:items-start mt-3 md:mt-5">
                <div className='border-b border-gray-200 pb-2 w-full flex flex-col md:flex-row gap-1 md:gap-0'>
                    <span className="w-full md:w-1/3 font-bold md:font-normal text-sm md:text-base"><b>Account Owner</b></span>
                    <div className="h-5 w-full md:w-1/3 bg-gray-300 rounded-lg animate-pulse"></div>
                </div>
            </div>
            <div className="flex flex-col md:flex-row md:items-start mt-3 md:mt-5">
                <div className='border-b border-gray-200 pb-2 w-full flex flex-col md:flex-row gap-1 md:gap-0'>
                    <span className="w-full md:w-1/3 font-bold md:font-normal text-sm md:text-base"><b>Hunter</b></span>
                    <div className="h-5 w-full md:w-1/3 bg-gray-300 rounded-lg animate-pulse"></div>
                </div>
            </div>

            <div className="flex items-center mt-3 md:mt-5 mb-2">
                <p className="font-bold text-lg md:text-2xl -ml-2 md:-ml-5 w-full text-[#1E293B]">Product Associated</p>
            </div>
            <br></br>
            {/* Product Ownership Section - Display only Remittance Financing, Insurance, and Insurance Renewal */}
            <div className="flex items-start mt-5">
                <div className='border-b border-gray-200 pb-2 w-full flex'>
                    <span className="w-1/3 gap-2 flex items-center">
                    <div className="h-5 w-5 bg-gray-300 rounded-lg animate-pulse"></div>
                    <b>Remittance</b>
                    </span>
                    <div className="h-5 w-1/3 bg-gray-300 rounded-lg animate-pulse"></div>
                </div>
            </div>
            <div className="flex items-start mt-5">
                <div className='border-b border-gray-200 pb-2 w-full flex'>
                    <span className="w-1/3 gap-2 flex items-center">
                    <div className="h-5 w-5 bg-gray-300 rounded-lg animate-pulse"></div>
                    <b>Financing</b>
                    </span>
                    <div className="h-5 w-1/3 bg-gray-300 rounded-lg animate-pulse"></div>
                </div>
            </div>

            <div className="flex items-start mt-5">
                <div className='border-b border-gray-200 pb-2 w-full flex'>
                    <span className="w-1/3 gap-2 flex items-center">
                    <div className="h-5 w-5 bg-gray-300 rounded-lg animate-pulse"></div>
                    <b>Insurance</b>
                    </span>
                    <div className="h-5 w-1/3 bg-gray-300 rounded-lg animate-pulse"></div>
                </div>
            </div>
            <div className="flex items-start mt-5">
                <div className='border-b border-gray-200 pb-2 w-full flex'>
                    <span className="w-1/3 gap-2 flex items-center">
                    <div className="h-5 w-5 bg-gray-300 rounded-lg animate-pulse"></div>
                    <b>Insurance Renewal</b>
                    </span>
                    <div className="h-5 w-1/3 bg-gray-300 rounded-lg animate-pulse"></div>
                </div>
            </div>
            <div className="flex items-center mt-3 md:mt-5 mb-2">
                <p className="font-bold text-lg md:text-2xl -ml-2 md:-ml-5 w-full text-[#1E293B]">General Information</p>
            </div>
            <br></br>
            {/* MM Account ID */}
            <div className="col-span-1 lg:col-span-2 flex flex-col md:flex-row md:items-start mt-3 md:mt-5">
                <div className='border-b border-gray-200 pb-2 w-full flex flex-col md:flex-row gap-1 md:gap-0'>
                    <span className="w-full md:w-1/6 font-bold md:font-normal text-sm md:text-base"><b>MM Account ID</b></span>
                    <div className="h-5 w-full md:w-1/3 bg-gray-300 rounded-lg animate-pulse"></div>
                </div>
            </div>
            {/* Nature of Business and Industry */}
            <div className="flex flex-col md:flex-row md:items-start mt-3 md:mt-5">
                <div className='border-b border-gray-200 pb-2 w-full flex flex-col md:flex-row gap-1 md:gap-0'>
                    <span className="w-full md:w-1/3 font-bold md:font-normal text-sm md:text-base"><b>Nature of Business</b></span>
                    <div className="h-5 w-full md:w-1/3 bg-gray-300 rounded-lg animate-pulse"></div>
                </div>
            </div>
            <div className="flex flex-col md:flex-row md:items-start mt-3 md:mt-5">
                <div className='border-b border-gray-200 pb-2 w-full flex flex-col md:flex-row gap-1 md:gap-0'>
                    <span className="w-full md:w-1/3 font-bold md:font-normal text-sm md:text-base"><b>Industry</b></span>
                    <div className="h-5 w-full md:w-1/3 bg-gray-300 rounded-lg animate-pulse"></div>
                </div>
            </div>
            {/* Relationship Strength */}
            <div className="col-span-1 lg:col-span-2 flex flex-col md:flex-row md:items-start mt-3 md:mt-5">
                <div className='border-b border-gray-200 pb-2 w-full flex flex-col md:flex-row gap-1 md:gap-0'>
                    <span className="w-full md:w-1/6 font-bold md:font-normal text-sm md:text-base"><b>Relationship Strength</b></span>
                    <div className="h-5 w-full md:w-1/3 bg-gray-300 rounded-lg animate-pulse"></div>
                </div>
            </div>
            {/* Street */}
            <div className="col-span-1 lg:col-span-2 flex flex-col md:flex-row md:items-start mt-3 md:mt-5">
                <div className='border-b border-gray-200 pb-2 w-full flex flex-col md:flex-row gap-1 md:gap-0'>
                    <span className="w-full md:w-1/6 font-bold md:font-normal text-sm md:text-base"><b>Street</b></span>
                    <div className="h-5 w-full md:w-1/3 bg-gray-300 rounded-lg animate-pulse"></div>
                </div>
            </div>

            {/* City */}
            <div className="col-span-1 lg:col-span-2 flex flex-col md:flex-row md:items-start mt-3 md:mt-5">
                <div className='border-b border-gray-200 pb-2 w-full flex flex-col md:flex-row gap-1 md:gap-0'>
                    <span className="w-full md:w-1/6 font-bold md:font-normal text-sm md:text-base"><b>City</b></span>
                    <div className="h-5 w-full md:w-1/3 bg-gray-300 rounded-lg animate-pulse"></div>
                </div>
            </div>

            {/* Post Code */}
            <div className="col-span-1 lg:col-span-2 flex flex-col md:flex-row md:items-start mt-3 md:mt-5">
                <div className='border-b border-gray-200 pb-2 w-full flex flex-col md:flex-row gap-1 md:gap-0'>
                    <span className="w-full md:w-1/6 font-bold md:font-normal text-sm md:text-base"><b>Post Code</b></span>
                    <div className="h-5 w-full md:w-1/3 bg-gray-300 rounded-lg animate-pulse"></div>
                </div>
            </div>

            {/* State */}
            <div className="col-span-1 lg:col-span-2 flex flex-col md:flex-row md:items-start mt-3 md:mt-5">
                <div className='border-b border-gray-200 pb-2 w-full flex flex-col md:flex-row gap-1 md:gap-0'>
                    <span className="w-full md:w-1/6 font-bold md:font-normal text-sm md:text-base"><b>State</b></span>
                    <div className="h-5 w-full md:w-1/3 bg-gray-300 rounded-lg animate-pulse"></div>
                </div>
            </div>
        </div>
    </div>
);

const AccountDetailsSquareSkeleton = () => (
    <div className="w-full">
        {/* Outer White Container */}
        <div className="bg-white rounded-2xl md:rounded-3xl shadow-sm p-4 md:p-6 mx-2 md:mx-8 mt-3 md:mt-5">
            <div className="h-3 md:h-4 w-20 md:w-24 bg-gray-200 rounded-lg animate-pulse"></div>
            <div className="h-8 md:h-12 mt-2 mb-4 md:mb-5 ml-1 animate-pulse rounded-lg bg-gray-300 w-3/4 md:w-1/2"></div>
    
            <div className="flex flex-row gap-2 overflow-x-auto scrollbar-hide pb-2">
                <div className="min-w-[100px] md:w-1/12 bg-gray-300 h-[36px] md:h-[40px] py-2 px-3 md:px-5 gap-2 rounded-lg border animate-pulse flex-shrink-0"></div>
                <div className="min-w-[100px] md:w-1/12 bg-gray-300 h-[36px] md:h-[40px] py-2 px-3 md:px-5 gap-2 rounded-lg border animate-pulse flex-shrink-0"></div>
                <div className="min-w-[100px] md:w-1/12 bg-gray-300 h-[36px] md:h-[40px] py-2 px-3 md:px-5 gap-2 rounded-lg border animate-pulse flex-shrink-0"></div>
            </div>
        </div>
    </div>
)

const AccountDetailsRelatedTabSkeleton = () => (
    <div className='w-full bg-white p-4 md:p-7 rounded-2xl md:rounded-3xl shadow-lg'>
        {/* Lead Ownership Section */}
        <div className="flex flex-col md:flex-row md:justify-between md:items-start gap-3 md:gap-0">
            <div className="flex items-center">
                <p className="font-bold text-lg md:text-2xl text-[#1E293B]">Associated TT Information</p>
            </div>
        </div>

        {/* Grid Container for All Rows */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-5 ml-2 md:ml-5 text-[#475569]">
            {/* Company Name and Hunter */}
            <div className="flex flex-col md:flex-row md:items-start mt-3 md:mt-5">
                <div className='border-b border-gray-200 pb-2 w-full flex flex-col md:flex-row gap-1 md:gap-0'>
                    <span className="w-full md:w-1/3 font-bold md:font-normal text-sm md:text-base"><b>Frequency of TT</b></span>
                    <div className="h-5 w-full md:w-1/3 bg-gray-300 rounded-lg animate-pulse"></div>
                </div>
            </div>
            <div className="flex flex-col md:flex-row md:items-start mt-3 md:mt-5">
                <p className='border-b border-gray-200 pb-2 w-full flex flex-col md:flex-row gap-1 md:gap-0'>
                    <span className="w-full md:w-1/3 font-bold md:font-normal text-sm md:text-base"><b>Next Expected TT</b></span>
                    <div className="h-5 w-full md:w-1/3 bg-gray-300 rounded-lg animate-pulse"></div>
                </p>
            </div>

            {/* Contact Method and Lead Source */}
            <div className="flex flex-col md:flex-row md:items-start mt-3 md:mt-5">
                <div className='border-b border-gray-200 pb-2 w-full flex flex-col md:flex-row gap-1 md:gap-0'>
                    <span className="w-full md:w-1/3 font-bold md:font-normal text-sm md:text-base"><b>Average TT Amount</b></span>
                    <div className="h-5 w-full md:w-1/3 bg-gray-300 rounded-lg animate-pulse"></div>
                </div>
            </div>
            <div className="flex flex-col md:flex-row md:items-start mt-3 md:mt-5">
                <div className='border-b border-gray-200 pb-2 w-full flex flex-col md:flex-row gap-1 md:gap-0'>
                    <span className="w-full md:w-1/3 font-bold md:font-normal text-sm md:text-base"><b>Previous TT Amount</b></span>
                    <div className="h-5 w-full md:w-1/3 bg-gray-300 rounded-lg animate-pulse"></div>
                </div>
            </div>
            <div className="flex flex-col md:flex-row md:items-start mt-3 md:mt-5">
                <div className='border-b border-gray-200 pb-2 w-full flex flex-col md:flex-row gap-1 md:gap-0'>
                    <span className="w-full md:w-1/3 font-bold md:font-normal text-sm md:text-base"><b>Tier</b></span>
                    <div className="h-5 w-full md:w-1/3 bg-gray-300 rounded-lg animate-pulse"></div>
                </div>
            </div>
            <div className="flex flex-col md:flex-row md:items-start mt-3 md:mt-5">
                <div className='border-b border-gray-200 pb-2 w-full flex flex-col md:flex-row gap-1 md:gap-0'>
                    <span className="w-full md:w-1/3 font-bold md:font-normal text-sm md:text-base"><b>Current Provider</b></span>
                    <div className="h-5 w-full md:w-1/3 bg-gray-300 rounded-lg animate-pulse"></div>
                </div>
            </div>
            <div className="flex flex-col md:flex-row md:items-start mt-3 md:mt-5">
                <div className='border-b border-gray-200 pb-2 w-full flex flex-col md:flex-row gap-1 md:gap-0'>
                    <span className="w-full md:w-1/3 font-bold md:font-normal text-sm md:text-base"><b>Current Rates</b></span>
                    <div className="h-5 w-full md:w-1/3 bg-gray-300 rounded-lg animate-pulse"></div>
                </div>
            </div>
            <div className="flex flex-col md:flex-row md:items-start mt-3 md:mt-5">
                <div className='border-b border-gray-200 pb-2 w-full flex flex-col md:flex-row gap-1 md:gap-0'>
                    <span className="w-full md:w-1/3 font-bold md:font-normal text-sm md:text-base"><b>Trade Facilities</b></span>
                    <div className="h-5 w-full md:w-1/3 bg-gray-300 rounded-lg animate-pulse"></div>
                </div>
            </div>
            <div className="flex flex-col md:flex-row md:items-start mt-3 md:mt-5">
                <div className='border-b border-gray-200 pb-2 w-full flex flex-col md:flex-row gap-1 md:gap-0'>
                    <span className="w-full md:w-1/3 font-bold md:font-normal text-sm md:text-base"><b>Reason of using TF</b></span>
                    <div className="h-5 w-full md:w-1/3 bg-gray-300 rounded-lg animate-pulse"></div>
                </div>
            </div>
            <div className="flex flex-col md:flex-row md:items-start mt-3 md:mt-5">
                <div className='border-b border-gray-200 pb-2 w-full flex flex-col md:flex-row gap-1 md:gap-0'>
                    <span className="w-full md:w-1/3 font-bold md:font-normal text-sm md:text-base"><b>Percentage of TT</b></span>
                    <div className="h-5 w-full md:w-1/3 bg-gray-300 rounded-lg animate-pulse"></div>
                </div>
            </div>
            <div className="col-span-1 lg:col-span-2 flex flex-col md:flex-row md:items-start mt-3 md:mt-5">
                <div className='border-b border-gray-200 pb-2 w-full flex flex-col md:flex-row gap-1 md:gap-0'>
                    <span className="w-full md:w-1/6 font-bold md:font-normal text-sm md:text-base"><b>Currencies</b></span>
                    <div className="h-5 w-full md:w-1/3 bg-gray-300 rounded-lg animate-pulse"></div>
                </div>
            </div>
            <div className="col-span-1 lg:col-span-2 flex flex-col md:flex-row md:items-start mt-3 md:mt-5">
                <div className='border-b border-gray-200 pb-2 w-full flex flex-col md:flex-row gap-1 md:gap-0'>
                    <span className="w-full md:w-1/6 font-bold md:font-normal text-sm md:text-base"><b>Target Country</b></span>
                    <div className="h-5 w-full md:w-1/3 bg-gray-300 rounded-lg animate-pulse"></div>
                </div>
            </div>

            <div className="flex items-center mt-3 md:mt-5 mb-3 md:mb-5">
                <p className="font-bold text-lg md:text-2xl -ml-2 md:-ml-5 w-full text-[#1E293B]">Associated Insurance Information</p>
            </div>
            <br></br>
            <div className="col-span-1 lg:col-span-2 mb-4">
                <div className="p-4 w-full h-48 md:h-64 rounded-lg bg-gray-200 animate-pulse"></div>
            </div>
            <div className="flex items-center mt-3 md:mt-5 mb-3 md:mb-5">
                <p className="font-bold text-lg md:text-2xl -ml-2 md:-ml-5 w-full text-[#1E293B]">Associated Financing Information</p>
            </div>
            <br></br>
            <div className="col-span-1 lg:col-span-2 mb-4">
                <div className="p-4 w-full h-48 md:h-64 rounded-lg bg-gray-200 animate-pulse"></div>
            </div>
            <div className="flex items-center mt-3 md:mt-5 mb-3 md:mb-5">
                <p className="font-bold text-lg md:text-2xl -ml-2 md:-ml-5 w-full text-[#1E293B]">Associated Opportunities</p>
            </div>
            <br></br>
            <div className="col-span-1 lg:col-span-2 mb-4">
                <div className="p-4 w-full h-48 md:h-64 rounded-lg bg-gray-200 animate-pulse"></div>
            </div>
        </div>
        </div>
)

export {SkeletonCard, StatisticsTabSkeleton, AccountDetailsSkeleton, AccountDetailsSquareSkeleton, AccountDetailsRelatedTabSkeleton};
